module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0548-min.3cd5f19d.jpg";